import React, { useState, useEffect } from "react";
import {
  Button,
  Container,
  Col,
  Form,
  Image,
  Nav,
  Row,
  Tooltip,
  OverlayTrigger, Spinner,
  Modal
} from "react-bootstrap";
import excl_i from "../../../assets/images/icons/excl_i.png";
import trash from "../../../assets/images/icons/trash.svg";
import { useNavigate, NavLink } from "react-router-dom";
import { useUserContext } from "../../../utils/hooks/UserContext";
import { useFormik } from "formik";
import * as Yup from "yup";
import { WithContext as ReactTags } from "react-tag-input";
import Select from "react-select";
import {Link} from 'react-router-dom'
import {
  coachAddProgram,
  coachAddSkill,
  coachBenefits,
  coachDeleteProgram,
  coachDeleteSkill,
  coachProfessions,
  coachTags,
  getCategoryList,
} from "../../../utils/api";
import Loader from "../../../Loader/Loader";
import { toast } from "react-toastify";
import { PulseLoader } from "react-spinners";

const EditProfileBenefits = (props) => {
  const navigate = useNavigate();
    const { getUserFromToken, user } = useUserContext();
    const [benefits, setbenefits] = useState(user?.benefits);
    const [isSubmitting, setisSubmitting] = useState(false);
      
    const onClickSave = async (values) => {
      try {
        // handle program
        setisSubmitting(true);
       
        // handle benefits
        const benefitString = Object.values(benefits).join(", ");
        const benefitData = new FormData();
        benefitData.append("benefits", benefitString);
        await coachBenefits(benefitData);
 
      } catch (error) {
        toast.error(error?.response?.data?.message || error?.message);
        setisSubmitting(false);
      }
  
      getUserFromToken();
      setisSubmitting(false);
    };
  
   
    useEffect(() => {
      const canonicalUrl = window.location.origin + window.location.pathname;
      let link = document.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonicalUrl);
  
    }, []);
  
    const handleBenefits = (event) => {
      setbenefits({ ...benefits, [event.target.name]: event?.target?.value });
    };
  
console.log("herere",benefits,user)
  return (
    <>
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter" centered>
      <div className="profile_edit_forms my_light_modal">
        {/* <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Modal heading</Modal.Title>
        </Modal.Header> */}
        <Form>
          <Container>
            <Row className='g-3'>
              <Col lg="12">
                  <Form.Label className="title fs-20">
                    Benefits of you as coach
                  </Form.Label>
                  <ul className="bc_list">
                    <li>
                      <Form.Control
                        className="mb-2"
                        type="text"
                        rows={3}
                        name="0"
                        value={benefits?.["0"]}
                        onChange={handleBenefits}
                        placeholder="Benefits 1"
                      />
                    </li>
                    <li>
                      <Form.Control
                        className="mb-2"
                        type="text"
                        rows={3}
                        name="1"
                        value={benefits?.["1"]}
                        onChange={handleBenefits}
                        placeholder="Benefits 2"
                      />
                    </li>
                    <li>
                      <Form.Control
                        className="mb-2"
                        type="text"
                        rows={3}
                        name="2"
                        value={benefits?.["2"]}
                        onChange={handleBenefits}
                        placeholder="Benefits 3"
                      />
                    </li>
                    <li>
                      <Form.Control
                        className="mb-2"
                        type="text"
                        rows={3}
                        name="3"
                        value={benefits?.["3"]}
                        onChange={handleBenefits}
                        placeholder="Benefits 4"
                      />
                    </li>
                    <li>
                      <Form.Control
                        className="mb-2"
                        type="text"
                        rows={3}
                        name="4"
                        value={benefits?.["4"]}
                        onChange={handleBenefits}
                        placeholder="Benefits 5"
                      />
                    </li>
                  </ul>
              </Col>
            </Row>
            <Row className='justify-content-end mt-4'>
              <Col sm="auto">
                  <Button variant='success' className='px-5' onClick={onClickSave}>Save</Button>
              </Col>
            </Row>
          </Container>
        </Form>
      </div>
    </Modal>
    </>
  );
}

export default EditProfileBenefits;